import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ProfileModel } from '../models/profile.model';
import { environment } from '../../../../environments/environment';
import { WorkshopModel } from '../../workshop/models/workshop.model';
import { RegistrationApprovalModel } from '../../workshop/models/registration-approval.model';
import { ContentModel } from '../../../shared/models/content.model';
import { PastWorkshopModel } from '../../held-workshop/models/past-workshop.model';
import { WorkshopRegistrationRequestModel } from '../../../shared/models/workshop-registration-request.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ProfileService {
  apiUrl: string = environment.baseApi + 'training/account/';

  constructor(private http: HttpClient) {}

  getMyProfile() {
    return this.http.get<ProfileModel>(this.apiUrl + 'my-profile/');
  }

  updateMyProfile(newProfile: any) {
    return this.http.post<ProfileModel>(
      this.apiUrl + 'my-profile/',
      newProfile,
    );
  }

  getMyWorkshopRegistrationRequests() {
    return this.http.get<WorkshopRegistrationRequestModel[]>(
      this.apiUrl + 'my-workshop-registration-requests/',
    );
  }

  getMyWorkshops() {
    return this.http.get<WorkshopModel[]>(this.apiUrl + 'my-workshops/');
  }
  getWorkshopStats() {
    return this.http.get<
      {
        dimension_no;
        dimension_title;
        workshops_count;
      }[]
    >(environment.baseApi + 'trainings/workshops/stats/');
  }

  getMyPastWorkshops() {
    return this.http.get<{
      data: PastWorkshopModel[];
      totalDuration: number;
      totalWorkshops: number;
    }>(this.apiUrl + 'registered-workshops/');
  }

  getMyRegistrationApprovalStatus() {
    return this.http.get<RegistrationApprovalModel>(
      this.apiUrl + 'get-my-registration-approval-status/',
    );
  }

  downloadContent(content: ContentModel) {
    return this.http.get(content.file_id, { responseType: 'blob' });
  }

  getWorkshopCertificateFile(workshopId: number): Observable<ContentModel> {
    return this.http.get<ContentModel>(
      environment.baseApi + `trainings/workshops/${workshopId}/certificate/`,
    );
  }
}
